import React from "react";
import { useSearchParams } from "react-router-dom";
import { ledgerArticles, ledgerFormats, ledgerTopics } from "../../data/ledger";
import { LedgerList } from "./LedgerList";
import { SectionLabel } from "../SectionLabel";
type FilterKey = "topic" | "format";
export function LedgerIndex() {
  const [params, setParams] = useSearchParams();
  const topic = params.get("topic") ?? "All";
  const format = params.get("format") ?? "All";
  const setFilter = (key: FilterKey, value: string) => {
    const next = new URLSearchParams(params);
    if (value === "All") next.delete(key);else next.set(key, value);
    setParams(next, {
      replace: true
    });
  };
  const visible = ledgerArticles.filter(a => (topic === "All" || a.topic === topic) && (format === "All" || a.format === format));
  const groups: {
    key: FilterKey;
    label: string;
    options: string[];
    active: string;
  }[] = [{
    key: "topic",
    label: "Topic",
    options: ["All", ...ledgerTopics],
    active: topic
  }, {
    key: "format",
    label: "Format",
    options: ["All", ...ledgerFormats],
    active: format
  }];
  return <section aria-labelledby="index-title" className="shell py-24 md:py-32" data-id="element-403" data-mp="2n2avgc49xo0w">
      <div className="grid grid-cols-12 gap-x-6 gap-y-10 pb-12" data-id="element-404" data-mp="2i3pw0ewuj8di">
        <div className="col-span-12 lg:col-span-4" data-id="element-405" data-mp="2i3zn65tmnlks">
          <SectionLabel data-id="element-406" data-mp="2e2o4yld322mm">Index</SectionLabel>
          <h2 id="index-title" className="mt-6 font-display text-[clamp(2rem,3.8vw,3.25rem)] leading-[1.08] text-navy" data-id="element-407" data-mp="2e3pfmoq6sn3t">
            Every entry.
          </h2>
        </div>
        <div className="col-span-12 space-y-5 lg:col-span-8 lg:self-end" data-id="element-408" data-mp="35udhk2zopwij">
          {groups.map(g => <div key={g.key} role="group" aria-label={`Filter by ${g.label.toLowerCase()}`} className="flex flex-wrap items-baseline gap-x-6 gap-y-2" data-id="element-409" data-mp="31qe3dr1vn9sc">
              <span className="eyebrow w-16 text-charcoal/70" data-id="element-410" data-mp="1qck4gmv6yizu">{g.label}</span>
              {g.options.map(o => {
            const active = g.active === o;
            return <button key={o} type="button" aria-pressed={active} onClick={() => setFilter(g.key, o)} className={`whitespace-nowrap border-b py-1 text-[13px] font-medium tracking-[0.04em] transition-colors duration-150 ease-ledger ${active ? "border-oxblood text-oxblood" : "border-transparent text-charcoal/70 hover:text-oxblood"}`} data-id="element-411" data-mp="1lftl9qo3b7a7">
                    {o}
                  </button>;
          })}
            </div>)}
        </div>
      </div>

      {visible.length === 0 ? <div className="border-t border-navy py-16" data-id="element-412" data-mp="u7s4wfjosubu">
          <p className="font-display text-2xl text-navy" data-id="element-413" data-mp="z4igapkjr1qx">Nothing filed here yet.</p>
          <button type="button" onClick={() => setParams(new URLSearchParams(), {
        replace: true
      })} className="link-rule mt-6" data-id="element-414" data-mp="l5iv5rw8t4zi">
            Clear filters
          </button>
        </div> : <LedgerList articles={visible} data-id="element-415" data-mp="6jd7cp11sjyp" />}
    </section>;
}